var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLawlibraryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#484848;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54,388.5v6.54a.252.252,0,0,1-.41.2A4.2,4.2,0,0,0,51,394.5a3.7,3.7,0,0,0-2.8.968.243.243,0,0,1-.4,0A3.7,3.7,0,0,0,45,394.5a4.2,4.2,0,0,0-2.59.74.252.252,0,0,1-.41-.2V388.5c0-.82,1.35-1.5,3-1.5a3.7,3.7,0,0,1,2.8.968.243.243,0,0,0,.4,0A3.7,3.7,0,0,1,51,387C52.65,387,54,387.68,54,388.5Z",
    transform: "translate(-40 -384)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawlibraryIcon);
export default __webpack_public_path__ + "static/media/lawlibraryIcon.a86e090ffc2ebc53e4ae0ebc51cdedd9.svg";
export { ForwardRef as ReactComponent };